<template>
  <v-row no-gutters>
    <v-col cols="6" sm="12" md="12" lg="6" class="mb-sm-5 mb-lg-0">
      <v-row no-gutters>
        <v-col cols="12" class="d-flex justify-center pa-4">
          <div class="d-flex align-center">
            <span
              class="zmdi mr-5 audit-result__device-icon"
              :class="`zmdi-${setDevice}`"
            ></span>
            <div class="d-flex flex-column mr-5">
              <span class="audit-result__device">
                {{ this.selectedItem.device }}
              </span>
              <span class="audit-result__label">
                {{ $t("message.common.loadingTime") }}
              </span>
            </div>
          </div>
          <span
            class="audit-result__loading-time"
            :class="`${loadingTimeColor(loadingTime.value)}--text`"
          >
            {{ `${loadingTime.value} ${secondsPlural(loadingTime.value)}` }}
          </span>
        </v-col>
        <v-col cols="12" class="pa-4">
          <div class="d-flex scale">
            <div class="d-flex flex-column" style="flex-grow: 3;">
              <span class="mx-auto mb-1 scale__label">
                {{ $t("message.analytics.scale.great") }}
              </span>
              <span class="green lighten-2 scale-time scale--start">3 s</span>
            </div>
            <div class="d-flex flex-column" style="flex-grow: 2;">
              <span class="mx-auto mb-1 scale__label">
                {{ $t("message.analytics.scale.good") }}
              </span>
              <span class="yellow lighten-2 scale-time">5 s</span>
            </div>
            <div class="d-flex flex-column" style="flex-grow: 3;">
              <span class="mx-auto mb-1 scale__label">
                {{ $t("message.analytics.scale.medium") }}
              </span>
              <span class="orange lighten-2 scale-time">8 s</span>
            </div>
            <div class="d-flex flex-column" style="flex-grow: 2;">
              <span class="mx-auto mb-1 scale__label">
                {{ $t("message.analytics.scale.weak") }}
              </span>
              <span class="red lighten-2 scale-time scale--end">
                {{ `${$t("message.common.moreThan")} 8 s` }}
              </span>
            </div>
            <div
              class="scale-indicator"
              :style="`left:${loadingTimeInPercents}%;`"
            >
              <span
                :style="
                  loadingTimeInPercents > 50 ? 'margin-left: -100px;' : ''
                "
              >
                {{ $t("message.common.yourSite") }}
              </span>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="6" sm="12" md="12" lg="6" class="pa-4 text--secondary">
      <span>{{ $t("message.analytics.siteLoadingInfo") }} </span>
      <a
        href="https://developers.google.com/web/tools/lighthouse/audits/first-meaningful-paint"
        target="_blank"
        rel="noopener noreferrer"
        >{{ $t("message.common.moreInformations") }}.</a
      >
    </v-col>
  </v-row>
</template>

<script>
import { polishPlurals } from "polish-plurals";

export default {
  name: "AnalyticsAuditResult",
  props: {
    selectedItem: {
      type: Object,
      required: true
    },
    audit: {
      type: Object,
      required: true
    }
  },
  computed: {
    loadingTime() {
      const performanceAudits = this.audit.data.performance.audits;
      const firstMeaningfulPaint = [
        ...performanceAudits.passed,
        ...performanceAudits.failed
      ].find(audit => audit.id === "first-meaningful-paint");

      return {
        value: (firstMeaningfulPaint.numericValue / 1000).toFixed(1),
        description: firstMeaningfulPaint.description
      };
    },
    loadingTimeInPercents() {
      const value = this.loadingTime.value * 10;
      return value <= 100 ? value : 100;
    },
    setDevice() {
      return this.selectedItem.device === "mobile"
        ? "smartphone-iphone"
        : "laptop";
    }
  },
  methods: {
    loadingTimeColor(loadingTime) {
      if (loadingTime >= 0 && loadingTime <= 3) return "green";
      if (loadingTime > 4 && loadingTime <= 8) return "orange";
      if (loadingTime > 9 && loadingTime <= 10) return "red";
    },
    secondsPlural(val) {
      return polishPlurals("sekunda", "sekundy", "sekund", val);
    }
  }
};
</script>

<style lang="scss" scoped>
.audit-result__device-icon {
  font-size: 44px;
}

.audit-result__device {
  text-transform: uppercase;
}

.audit-result__label {
  font-size: 14px;
  color: $gray;
}

.audit-result__loading-time {
  color: $warning;
  font-size: 42px;
  font-weight: 700;
  text-transform: uppercase;
}

.scale {
  width: 100%;
  position: relative;

  &-time {
    display: block;
    font-size: 15px;
    padding: 4px 0;
    text-align: center;
  }

  &__label {
    color: $gray-light;
    font-size: 13px;
  }
}

.scale-indicator {
  display: block;
  font-size: 12px;
  font-weight: 600;
  position: absolute;
  text-transform: uppercase;
  top: 20px;
  transform: translateX(-20px);
  transition: all 0.5s ease-in-out;
  width: 120px;

  span {
    display: block;
    margin-top: 2px;
  }

  &::before {
    background-color: $dark;
    content: "";
    display: block;
    height: 36px;
    position: relative;
    width: 4px;
  }
}

.scale--start {
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}

.scale--end {
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}
</style>
